
define('text!modules/targeting/location/templates/bin_title.html',[],function () { return '<div class="header-c title">{{bin_action}}d {{bin_label}}: </div>\n';});

